import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id B5191E73-1C38-4B78-9018-F8216855C61A
 * name weather-hurricane-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-hurricane-outline.svg
 * tags
 * - Weather 
 * - Nature 
 * - Agriculture 
 */
export const WeatherHurricaneOutlineIcon = createSvgIcon(<><path d="M12 14C13.11 14 14 13.11 14 12C14 10.9 13.11 10 12 10C10.9 10 10 10.9 10 12C10 13.11 10.9 14 12 14M18 2C17.1 2.68 16.26 3.45 15.5 4.29C15.21 4.61 14.93 4.95 14.66 5.29C14.62 5.34 14.59 5.39 14.56 5.45C14.31 5.94 14.5 6.54 15 6.79C16.86 7.86 18 9.85 18 12C18 18.41 13.08 20.71 9.54 21.54C7.55 22 6 22 6 22C6.9 21.32 7.74 20.55 8.5 19.71C8.79 19.39 9.07 19.05 9.34 18.71C9.38 18.66 9.41 18.61 9.44 18.55C9.69 18.06 9.5 17.46 9 17.21C7.14 16.14 6 14.15 6 12C6 5.59 10.93 3.29 14.47 2.46C16.45 2 18 2 18 2M9.44 7.47C8.61 8.5 8 9.93 8 12C8 13.43 8.75 14.74 9.96 15.46C11.2 16.12 11.78 17.5 11.47 18.8C12.67 18.27 13.76 17.54 14.56 16.53C15.39 15.5 16 14.07 16 12C16 10.57 15.25 9.26 14.04 8.54C12.8 7.88 12.22 6.5 12.54 5.2C11.33 5.73 10.24 6.47 9.44 7.47Z" /></>, 'WeatherHurricaneOutlineIcon');
export default WeatherHurricaneOutlineIcon